import * as React from 'react'
import { styles } from './styles.css'
import instagram from './instagram.svg'

type Props = {
  renderButton: () => React.ReactNode
  onClick?: React.MouseEventHandler
}

export const DesktopSidebar: React.FC<Props> = ({ renderButton, onClick }) => {
  return (
    <nav className={styles.sidebar}>
      <ul className={styles.links}>
        <li>
          <a className={styles.link} href="#features" onClick={onClick}>
            <span className={styles.linkTitle}>FEATURES</span>
            <span className={styles.linkSubtitle}>3つの特徴</span>
          </a>
        </li>
        <li>
          <a className={styles.link} href="#howto" onClick={onClick}>
            <span className={styles.linkTitle}>HOW TO USE</span>
            <span className={styles.linkSubtitle}>お届けから飾るまで</span>
          </a>
        </li>
        <li>
          <a className={styles.link} href="#vase" onClick={onClick}>
            <span className={styles.linkTitle}>FLOWER VASE</span>
            <span className={styles.linkSubtitle}>ぴったりの花器もどうぞ！</span>
          </a>
        </li>
        <li>
          <a className={styles.link} href="#plan" onClick={onClick}>
            <span className={styles.linkTitle}>PLAN</span>
            <span className={styles.linkSubtitle}>お届け内容・料金</span>
          </a>
        </li>
        <li>
          <a className={styles.link} href="#about" onClick={onClick}>
            <span className={styles.linkTitle}>ABOUT</span>
            <span className={styles.linkSubtitle}>私たち、FLOWERについて</span>
          </a>
        </li>
        <li>
          <a className={styles.link} href="#faq" onClick={onClick}>
            <span className={styles.linkTitle}>FAQ</span>
            <span className={styles.linkSubtitle}>よくある質問</span>
          </a>
        </li>
        <a className={styles.link} href="https://www.instagram.com/flowr_is/" target="_blank">
          <img src={instagram} width="36px" height="36px" />
        </a>
        <div className={styles.button}>
          {renderButton()}
        </div>
      </ul>
      <ul className={styles.legalLinks}>
        <li>
          <a className={styles.legalLink} href="https://flowr.is/">
            FLOWER公式サイト
          </a>
        </li>
        <li>
          <a className={styles.legalLink} href="https://flowr.jp/">
            運営会社
          </a>
        </li>
        <li>
          <a className={styles.legalLink} href="https://flowr.is/policy">
            プライバシーポリシー
          </a>
        </li>
        <li>
          <a className={styles.legalLink} href="https://flowr.is/terms">
            利用規約
          </a>
        </li>
        <li>
          <a className={styles.legalLink} href="https://flowr.is/commercial">
            特定商取引法に基づく表示
          </a>
        </li>
      </ul>
    </nav>
  )
}
